import { Fragment, useState } from "react";

export default (props) => {
    const [editing, setEditing] = useState(false);
    const [formData, setFormData] = useState({
        fName: props.ctx.profile && props.ctx.profile.fName,
        lName: props.ctx.profile && props.ctx.profile.lName,
        phone: props.ctx.profile && props.ctx.profile.phone,
    });

    const handleChange = (e) => {
        setFormData({...formData, [e.target.name]: e.target.value});
    };

    const handleSave = () => {
        props.ctx.profile.fName = formData.fName;
        props.ctx.profile.lName = formData.lName;
        props.ctx.profile.phone = formData.phone;
        props.ctx.ajax(window.config.api+'/profile/change_profile' , {
            fName :formData.fName,
            lName :formData.lName,
            phone :formData.phone,
            authToken:props.ctx.auth,
        } ).then(function (res) {

            props.ctx._notif(res.status,res.message)
            setEditing(false);
        })

    };

    return (
        <Fragment>
            <div className="container mt-4 mb-4 dashboard">
                <h5 className=" mb-4">داشبورد کاربر</h5>
                <div className="row g-3">

                    <div className="col-md-6">
                        <div className="card text-center">
                            <div className="card-body">
                                <h5 className="card-title">بالانس ریالی
                                    &nbsp;
                                    <props.ctx.NavLink  className={'btn btn-sm btn-primary text-white'} to={window.config.staticAddress+"/profile/charge/tom"} >شارژ</props.ctx.NavLink>
                                </h5>
                                <p className="card-text text-success">
                                    {props.ctx.addCommos(props.ctx.profile.balance, 2)} تومان
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="card text-center">
                            <div className="card-body">
                                <h5 className="card-title">
                                    بالانس دلاری
                                    &nbsp;
                                    <props.ctx.NavLink  className={'btn btn-sm btn-primary text-white'} to={window.config.staticAddress+"/profile/charge/usdt"} >شارژ</props.ctx.NavLink>
                                </h5>
                                <p className="card-text text-primary">
                                    ${props.ctx.addCommos(props.ctx.profile.usd_balance, 2)}
                                </p>

                            </div>
                        </div>
                    </div>

                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                <h5 className="card-title">اطلاعات کاربری</h5>
                                <ul className="list-unstyled mb-0">
                                    <li>
                                        <strong>نام:</strong>{" "}
                                        {editing ? (
                                            <input
                                                type="text"
                                                name="fName"
                                                className="form-control d-inline w-auto"
                                                value={formData.fName}
                                                onChange={handleChange}
                                            />
                                        ) : (
                                            <span onClick={() => setEditing(true)} style={{cursor: 'pointer'}}>
                        {props.ctx.profile.fName}
                      </span>
                                        )}
                                        {" "}
                                        {editing ? (
                                            <input
                                                type="text"
                                                name="lName"
                                                className="form-control d-inline w-auto ms-2"
                                                value={formData.lName}
                                                onChange={handleChange}
                                            />
                                        ) : (
                                            <span onClick={() => setEditing(true)} style={{cursor: 'pointer'}}>
                        {props.ctx.profile.lName}
                      </span>
                                        )}
                                    </li>
                                    <li>
                                        <strong>ایمیل:</strong> {props.ctx.profile.email}
                                    </li>
                                    <li>
                                        <strong>شماره تلفن:</strong>{" "}
                                        {editing ? (
                                            <input
                                                type="text"
                                                name="phone"
                                                className="form-control d-inline w-auto"
                                                value={formData.phone}
                                                onChange={handleChange}
                                            />
                                        ) : (
                                            <span onClick={() => setEditing(true)} style={{cursor: 'pointer'}}>
                        {props.ctx.profile.phone}
                      </span>
                                        )}
                                    </li>
                                    <li><strong>کد کاربری:</strong> {props.ctx.profile.id}</li>
                                </ul>

                                {editing && (
                                    <button className="btn btn-success mt-3" onClick={handleSave}>
                                        ذخیره تغییرات
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </Fragment>
    );
};
